import { Variety } from '../../../../../../services/entities/impl/blfApi/schemas/variety';
import { StagesCountDataDisplay } from '../../../../../reports/blueberry/components/StagesCountDataDisplay';
import { BlockPointData } from '../../../hooks/useGetBlockPoints';
import { useStagesCountDataset } from '../hooks/useStagesCountDataset';
import { StageCount } from '../types';

type Props = {
  point: BlockPointData;
  stages: Variety['stages'];
};

export const PointStageDataDisplay = ({ point, stages }: Props) => {
  // NOTE: Mapbox stringify's properties on PointFeatures that are non-primitives, like arrays or objects
  const stageCounts: StageCount[] = JSON.parse(
    point.stageCounts as unknown as string
  );

  const dataset = useStagesCountDataset(stageCounts, stages);

  return (
    <StagesCountDataDisplay dataset={dataset} totalLabel={'Image total'} />
  );
};
